import React, { useEffect } from "react";
import Router from "./routes";
import { useWeb3React } from "@web3-react/core";
import { connectors } from "./util/connector";

const App = () => {
  const { activate } = useWeb3React();
  useEffect(() => {
    const provider = localStorage.getItem("provider");
    if (provider) activate(connectors[provider]);
  }, []);
  return (
    <div>
      <Router />
    </div>
  );
};

export default App;
